import { FieldRuleModel } from "./field-rule.model";

export class FieldConfigModel {
  fieldName: string;
  rules: FieldRuleModel[];
}
